export default __webpack_public_path__ + "static/media/logo2.f5882e37.png";